/* =========================================================
   PRIX PROMO : UNIQUEMENT SUR LES FICHES PRODUIT
   ========================================================= */
   
   document.addEventListener('DOMContentLoaded', function () {
  initMorganSaleBadges();

  document.addEventListener('shopify:section:load', function () {
    initMorganSaleBadges();
  });
});

function initMorganSaleBadges() {

  const priceContainers = document.querySelectorAll('product-price [ref="priceContainer"]');

  priceContainers.forEach(function (container) {

    if (container.querySelector('.morgan-sale-badge')) {
      return;
    }

    const salePriceEl = container.querySelector('.price');
    const comparePriceEl = container.querySelector('.compare-at-price');

    if (!salePriceEl || !comparePriceEl) {
      return;
    }

    const salePrice = parsePrice(salePriceEl.textContent);
    const comparePrice = parsePrice(comparePriceEl.textContent);

    if (!salePrice || !comparePrice || comparePrice <= salePrice) {
      return;
    }

    const discountPercent = Math.round(((comparePrice - salePrice) / comparePrice) * 100);

    if (discountPercent <= 0) {
      return;
    }

    const badge = document.createElement('span');
    badge.className = 'morgan-sale-badge';
    badge.textContent = '-' + discountPercent + ' %';

    container.insertBefore(badge, container.firstChild);

  });
}

function parsePrice(priceText) {

  if (!priceText) return null;

  let cleaned = priceText
    .replace(/\s/g, '')
    .replace(/€/g, '')
    .replace(/\u00A0/g, '')
    .replace(/\./g, '')
    .replace(',', '.');

  const value = parseFloat(cleaned);

  return isNaN(value) ? null : value;
}

/* === MT : ETA livraison sur fiche produit (28/06/2026) === */
(function(){
  if(location.pathname.indexOf('/products/')===-1) return;
  function addBiz(base,n){var x=new Date(base.getTime());var a=0;while(a<n){x.setDate(x.getDate()+1);var w=x.getDay();if(w!==0&&w!==6)a++;}return x;}
  function fmt(d){return ('0'+d.getDate()).slice(-2)+'/'+('0'+(d.getMonth()+1)).slice(-2);}
  function inject(){
    var price=document.querySelector('.product-details product-price');
    if(!price||document.getElementById('mt-eta'))return;
    var now=new Date();
    var el=document.createElement('div');
    el.id='mt-eta';
    el.style.cssText='display:flex;align-items:center;gap:8px;margin:12px 0;font-size:15px;color:#1a2233;min-height:22px;';
    el.innerHTML='<span style="font-size:18px" aria-hidden="true">🚚</span><span>Recevez-le entre le <b style="font-weight:700">'+fmt(addBiz(now,3))+'</b> et le <b style="font-weight:700">'+fmt(addBiz(now,6))+'</b></span>';
    price.after(el);
  }
  if(document.readyState!=='loading')inject();else document.addEventListener('DOMContentLoaded',inject);
  document.addEventListener('shopify:section:load',inject);
})();
